var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"towers"},[_c('div',{staticClass:"towers-container"},[_c('div',{staticClass:"container-game",class:['game-' + _vm.towersRisk]},_vm._l((8),function(row){return _c('TowersRow',{key:row,attrs:{"row":row - 1}})}),1),_c('TowersControls')],1),_c('Bets')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }